import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1B8CD437-1CE6-4493-9C57-5E367B47A0BF
 * name view-sequential-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-sequential-outline.svg
 * tags
 * - View 
 */
export const ViewSequentialOutlineIcon = createSvgIcon(<><path d="M3 5V19H21V5H3M19 7V9H5V7H19M19 11V13H5V11H19M5 17V15H19V17H5Z" /></>, 'ViewSequentialOutlineIcon');
export default ViewSequentialOutlineIcon